import { WORKSPACE_TIMEZONES } from "@artisancode/api-types";
import { z } from "zod";

export const workspaceSchema = z.object({
  name: z.string().min(3, "Nama workspace minimal 3 karakter"),
  slug: z
    .string()
    .min(3, "Slug minimal 3 karakter")
    .regex(
      /^[a-z0-9]+(-[a-z0-9]+)*$/,
      "Slug hanya huruf kecil, angka, dan tanda hubung",
    ),
  copyMasterFromWorkspaceId: z.string().optional(),
  timezone: z.enum(WORKSPACE_TIMEZONES),
});

export type WorkspaceFormValues = z.infer<typeof workspaceSchema>;

export const defaultWorkspaceValues: WorkspaceFormValues = {
  name: "",
  slug: "",
  copyMasterFromWorkspaceId: "",
  timezone: "Asia/Jakarta",
};
